<template>
	<div class="div-wrapper-subsection">
		<div style="width: 1200px;margin: 0 auto;position: relative;height: 100%;">
			<div class="group-15" style="left: 100px;">
				<div class="text-wrapper-37">——加入我们</div>
				<div class="text-wrapper-38">
					助力中国企业健康成长
					<br />
					与朗乾律师事务所携手共进、成为改变的力量
				</div>
				<div class="text-wrapper-39">
					在这个充满挑战与机遇的时代，法律不仅是冰冷的规则，更是温暖hearted的力量我们，
					<br />
					一个致力于守护公正、追求卓越的律师事务所，
					<br />
					正寻找那些心中有火、眼中有光的你，
					<br />
					一起踏上这段不凡的旅程。
				</div>
			</div>
			<div class="group-14" style="left: 100px;">
				<div class="overlap-group-5" @mouseover="changeToHover" @mouseout="resetImage" @click="nav_move">
					<div class="text-wrapper-36">探索更多内容</div>
					<!-- <img class="vector-4" alt="Vector" src="/img/vector-2-1.svg" /> -->

					<img class="vector-4" alt="Vector" :src="imgSrc" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from '../../../router';
	export default {
		name: "JoinUsSection",
		data() {
			return {
				imgSrc: '/img/vector-2-1.svg'
			}
		},
		methods: {
			nav_move(){
		
				router.push({
					path: '/JoinUsPage'
				})
			},
			changeToHover() {
				this.imgSrc = '/img/Vectorh.png' // 鼠标移入时的图片
			},
			resetImage() {
				this.imgSrc = '/img/vector-2-1.svg' // 鼠标移出还原图片
			}
		}
	};
</script>

<style>
	.div-wrapper-subsection {
		background-image: url(/img/mask-group-6.png);
		background-size: 100% 100%;
		height: 499px;
		left: 0;
		position: absolute;
		top: 2705px;
		width: 100%;
		min-width: 1200px; /* 确保最小宽度 */
	}

	.div-wrapper-subsection .group-14 {
		height: 42px;
		position: absolute;
		top: 377px;
		width: 146px;
	}

	.div-wrapper-subsection .overlap-group-5 {
		border: 1px solid;
		border-color: #ffffff;
		border-radius: 21px;
		height: 42px;
		position: relative;
		width: 144px;
		color: #fff;
	}

	.div-wrapper-subsection .overlap-group-5:hover {
		background-color: #ffffff;
		color: #000 !important;
	}

	.div-wrapper-subsection .text-wrapper-36 {
		/* color: #ffffff; */
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 12px;
		font-weight: 400;
		left: 25px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 11px;
	}

	.div-wrapper-subsection .vector-4 {
		height: 7px;
		left: 104px;
		object-fit: cover;
		position: absolute;
		top: 16px;
		width: 13px;
	}

	.div-wrapper-subsection .group-15 {
		height: 237px;
		position: absolute;
		top: 80px;
		width: 598px;
	}

	.div-wrapper-subsection .text-wrapper-37 {
		color: var(--q-pd-79g);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 12px;
		font-weight: 500;
		left: 0;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 0;
	}

	.div-wrapper-subsection .text-wrapper-38 {
		color: var(--q-pd-79g);
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 28px;
		font-weight: 400;
		left: 0;
		letter-spacing: 0;
		line-height: 36px;
		position: absolute;
		top: 29px;
	}

	.div-wrapper-subsection .text-wrapper-39 {
		color: var(--q-pd-79g);
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 16px;
		font-weight: 500;
		left: 0;
		letter-spacing: 0;
		line-height: 24px;
		opacity: 0.8;
		position: absolute;
		top: 141px;
	}

	/* 确保在移动设备上也能正常显示 */
	@media screen and (max-width: 1200px) {
		.div-wrapper-subsection {
			min-width: 1200px;
			overflow-x: auto;
		}
	}
</style>